import { createContext } from 'react';

import {
  IBAuth0Role,
  MultiStepResults,
  RoleUpdateRequest,
} from '@totem/components/administration/auth0/roles/types';

interface Context {
  loading: boolean;
  data: IBAuth0Role[];
  editingRole: IBAuth0Role | null;
  modalOpen: boolean;
  syncing: boolean;
  syncResult: MultiStepResults | null;
  showSyncResults: boolean;
  onRefresh: () => void;
  onEdit: (role: IBAuth0Role) => void;
  onModalClose: () => void;
  onSave: (roleId: string, update: RoleUpdateRequest) => void;
  onSync: () => void;
  onCloseSyncResults: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  editingRole: null,
  modalOpen: false,
  syncing: false,
  syncResult: null,
  showSyncResults: false,
  onRefresh: () => {},
  onEdit: () => {},
  onModalClose: () => {},
  onSave: () => {},
  onSync: () => {},
  onCloseSyncResults: () => {},
});
